if (!customElements.get('multicolumn-slider')) {
  customElements.define(
    'multicolumn-slider',
    class MulticolumnSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.multicolumn__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.controls = this.parentElement;

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);

        this.sliderInstance = false;

        if (!this.enableSlider || !this.sliderWrapper) return;

        this.mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        this.mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (this.mql.matches) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10 || 0;

        this.sliderOptions = {
          slidesPerView: this.tabletItems > 3 ? 3 : this.tabletItems,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.controls.querySelector(this.selectors.nextEl),
            prevEl: this.controls.querySelector(this.selectors.prevEl),
          },
          pagination: false,
          breakpoints: {
            1280: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          watchOverflow: true,
          threshold: 2,
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);

        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}
